module.exports = __webpack_public_path__ + "static/media/icon6.75ea8ed9.png";